import { useRouter } from 'next/router';
import { ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import GeneralPrintingOrders from '@/modules/packhouse/printingOrders/components/GeneralPrintingOrders';
import Header from '@/modules/packhouse/printingOrders/components/Header';
import SupervisorsListing from '@/modules/packhouse/printingOrders/components/SupervisorsListing';
import Tabs from '@/shared/components/atoms/Tabs';
import { getLocalizedDate } from '@/shared/lib/dates';

export default function PrintingOrders(): ReactElement {
  const { t } = useTranslation('common');
  const { query } = useRouter();
  const [date, setDate] = useState(new Date());
  const formatedDate = useMemo(
    () => getLocalizedDate({ date, formatDate: 'yyyy-MM-dd' }),
    [date]
  );
  return (
    <section>
      <Header date={date} setDate={setDate} />
      <div className='mt-32 flex flex-col gap-32'>
        <Tabs
          tabsList={[
            {
              id: 1,
              type: t('general'),
              label: t('general-printing-orders'),
            },
            {
              id: 0,
              type: 'packhouse',
              label: t('packhouse-printing-orders'),
            },
          ]}
          getLabel={(tab) => tab.label}
          getValue={(tab) => tab.type}
          tabQueryIndicator='type'
          variant='connected'
          defaultValue='general'
        />
        {query.type === 'packhouse' ? (
          <SupervisorsListing date={formatedDate} />
        ) : (
          <GeneralPrintingOrders date={formatedDate} />
        )}
      </div>
    </section>
  );
}
